import { AuthRequest } from '../../../../services/Auth';

const MyApps = () => window.location.href = `${AuthRequest.getAuthUrl()}/select-profile`;

export default MyApps;